import axios from 'axios'
import store from '@/store'
export default () => {
  return axios.create({
    baseURL: `https://sandbox.lease.complement-it.com/api/`,
    headers: {
      Authorization: `Bearer ${store.state.token}`
    }
  })
}
